import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { faqs } from "../mock";
import JsonLd from "./JsonLd";

const FAQ = ({ heading = "Frequently Asked Questions", subtitle, items }) => {
  const list = items || faqs;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: list.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="bg-brand-cream py-20" id="faq">
      <JsonLd data={schema} id="faq-schema" />
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-10">
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            FAQ
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl">
            {heading}
          </h2>
          <div className="w-20 h-1 bg-brand-orange rounded-full mx-auto mt-4" />
          {subtitle && <p className="text-slate-600 mt-4">{subtitle}</p>}
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {list.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-2xl border border-black/5 shadow-sm px-5"
            >
              <AccordionTrigger className="text-left font-display font-semibold text-brand-navy hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
